import React from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { NewActionContainer } from './ui/NewAction'
import { NewActionTitle } from './ui/NewActionTitle'

const NewAction = ({
  show,
  list,
  color,
  bg,
  onSubmit,
  onCancel,
  defaultTitle = null,
}) => (
  <AnimatePresence>
    {show ? (
      <motion.div
        key="newaction"
        // flow like an existing ActionCard row (left-aligned) so the card
        // lines up with the other cards and doesn't appear inset
        style={{ width: '100%' }}
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        // on cancel, scale the card down to nothing (linear)
        exit={{ scale: 0, transition: { duration: 0.2, ease: 'linear' } }}
      >
        <NewActionContainer color={color} bg={bg}>
          <NewActionTitle
            bg={bg}
            color={color}
            onSubmit={onSubmit}
            onCancel={onCancel}
            placeholder="New Action"
            defaultTitle={defaultTitle}
          />
        </NewActionContainer>
      </motion.div>
    ) : null}
  </AnimatePresence>
)

export default NewAction
